export default "__VITE_ASSET__DeB0tee9__"